import SDIcon from './SDIcon'

const IconCarbonPauseOutline = (props) => (
  <SDIcon title='Email' {...props}>
    <polygon points='14 10 12 10 12 22 14 22 14 10 14 10' />
    <polygon points='20 10 18 10 18 22 20 22 20 10 20 10' />
    <path
    d='M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z'
    transform='translate(0 0)'
    />
  </SDIcon>
)

export default IconCarbonPauseOutline
